import { IFreightAvailableDetailed } from '@okcargo-apps/shared-domain';

export interface IFreightAvailableDetailedVM {
  item: IFreightAvailableDetailed | null;
  isLoading: boolean;
  error: Error | undefined;
  /** True when an action that requires the backend cannot be performed (no connectivity). */
  actionsDisabled: boolean;
}

export interface IFreightAvailableFilters {
  originCountryCode?: string;
  originStateCode?: string;
  destinationCountryCode?: string;
  destinationStateCode?: string;
}

export interface IFreightAvailableQuery {
  uiFilters: IFreightAvailableFilters | null;
}

export interface IFreightAvailableAdditionalQuery {
  uiFilters: IFreightAvailableFilters;
}

// TODO review and use enum. It is a backend value but not a frontend domain status
export const FREIGHT_AVAILABLE_STATUS = 'CREATED';
